module.exports = __webpack_public_path__ + "static/favicon.eb2cb75a.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicons/favicon.ico
// module id = 423
// module chunks = 114276838955818